/* 
Object:         User (Gebruiker)
Description:    Logic and events for the module User (Gebruiker)
Used in:        User / Tabstrip User
*/

import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings     from "../appsettings";
import * as dialog          from "../dialog";
import * as fileDownload    from "../fileDownload";
import * as form            from "../form";
import * as listbox         from "../listbox";
import * as main            from "../main";
import * as navigation      from "../navigation";
import * as viewmode        from "../viewmode";
import * as grid            from "../grid";

let _msg_notsaved = "";
let _userId = 0;

// constants
const PagerVersionWPagerProfiles = 370;

// messages
let E_Check_P2000_notification = "";
let E_Check_Precom_notification = "";
let E_Check_Agendaonderbezetting_notification = "";
let E_Check_Alarmenonderbezetting_notification = "";
let E_Check_Uitrukvoorstel_notification = "";

let currentSelectedGroupId: number;
let currentSelectedAdditionalGroupId: number;

/**
* Delete a user (user message 'confirm to remove')
*/
export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    let event = e;
    let data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as UserGridVM;
        removeUser(dataItem.UserID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

/**
* Action remove a user (from the grid)
* @param { number } userId
*/
export function removeUser(userId: number): void {

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("User/Delete") + "?userId=" + userId,
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            navigation.navigateToSpecificUrl("Module/LoadModule");
        }
    });
}

export function copyItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as UserGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("User/Copy?userId=" + dataItem.UserID + "&breadcrumbLabel=" + dataItem.FullName);
}

/**
* Action edit a user (from the grid)
* Redirects to the user to edit with the id
*/
export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as UserGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("User/Edit_Tabstrip?userId=" + dataItem.UserID + "&breadcrumbLabel=" + dataItem.FullName);
}

/**
* Show a item from the grid. (action)
*/
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Set mode
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as UserGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("User/Show_Tabstrip?userId=" + dataItem.UserID + "&breadcrumbLabel=" + dataItem.FullName);
}

export function extraToolbarButton0_Clicked(): void {
    const url = 'User/ExportAllUsersCurrentNode';
    const filename = 'Export_UsersAll_' + fileDownload.getDateTimeString() + '.xlsx';
    const loaderId = 'extraToolbarButton0Loader';
    fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
}

export function extraToolbarButton1_Clicked(): void {
    const url = 'User/ExportAllUsersNodesDown';
    const filename = 'Export_UsersAll_' + fileDownload.getDateTimeString() + '.xlsx';
    const loaderId = 'extraToolbarButton1Loader';
    fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
}

export function extraToolbarButton2_Clicked(): void {
    const url = 'User/ExportAllPagerConfig';
    const filename = 'Export_UsersAllPagerConfig_' + fileDownload.getDateTimeString() + '.xlsx';
    const loaderId = 'extraToolbarButton2Loader';
    fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
}

export function extraToolbarButton3_Clicked(): void {
    const url = 'User/ExportAllPagerConfigNodesDown';
    const filename = 'Export_UsersAllDownPagerConfig_' + fileDownload.getDateTimeString() + '.xlsx';
    const loaderId = 'extraToolbarButton3Loader';
    fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
}

export function extraToolbarButton4_Clicked(): void {
    const url = 'User/ExportAllPagerProfileNodesDown';
    const filename = 'Export_UsersAllDownAllPagerProfile_' + fileDownload.getDateTimeString() + '.xlsx';
    const loaderId = 'extraToolbarButton4Loader';
    fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
}

/**
* Init tab general
*/
export function init_Tab_General(msg_Check_P2000_notification: string,
    msg_Check_Precom_notification: string,
    msg_Check_Agendaonderbezetting_notification: string,
    msg_Check_Alarmenonderbezetting_notification: string,
    msg_Check_Uitrukvoorstel_notification: string) {

    E_Check_P2000_notification = msg_Check_P2000_notification;
    E_Check_Precom_notification = msg_Check_Precom_notification;
    E_Check_Agendaonderbezetting_notification = msg_Check_Agendaonderbezetting_notification;
    E_Check_Alarmenonderbezetting_notification = msg_Check_Alarmenonderbezetting_notification;
    E_Check_Uitrukvoorstel_notification = msg_Check_Uitrukvoorstel_notification;

    $("#NewPassword").val('');
}

/**
* Response
* @param {bool} succesfully
* @param {string} msg
*/
export function makeResponseData(succesfully: boolean, msg: string): responseModel {
    return {
        Succesfully: succesfully,
        Message: msg
    };
}

/**
* Form submission
* @param {event} e
*/
export function onFormSubmit(e: JQuery.Event & { model: UserItemVM }): void {

    // Prevent default behaviour
    e.preventDefault();

    let validateStr = clientSideValidation();

    if (validateStr != "") {
        const responseData = makeResponseData(false, validateStr);
        form.showServerResponse("", responseData, function () { });
    }
    else {
        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl(e.model.FormAction),
            data: e.model,
            success: function (responseData: responseModel | undefined | null) {
                form.showServerResponse("", responseData, function () { });
            }
        });
    }
}


export function validateNotification(): string {

    let validateResult = "";

    const valANVal = main.getKendoCheckBoxGroupValue("ANVal");
    const valPNVal = main.getKendoCheckBoxGroupValue("PNVal");

    if (!(valANVal & 4) && !(valPNVal & 4)) {
        validateResult += E_Check_P2000_notification + "\r\n";
    }

    if (!(valANVal & 1) && !(valPNVal & 1)) {
        validateResult += E_Check_Precom_notification + "\r\n";
    }

    if (!(valANVal & 2) && !(valPNVal & 2)) {
        validateResult += E_Check_Agendaonderbezetting_notification + "\r\n";
    }

    if (!(valANVal & 8) && !(valPNVal & 8)) {
        validateResult += E_Check_Alarmenonderbezetting_notification + "\r\n";
    }

    if (!(valANVal & 16) && !(valPNVal & 16)) {
        validateResult += E_Check_Uitrukvoorstel_notification + "\r\n";
    }

    return validateResult;
}


/**
* Client side validation
*/
export function clientSideValidation(): string {
    const notificationValStr = validateNotification();

    const txtarea = $("#notificationvalidation").data("kendoTextArea");
    if (txtarea != undefined) {
        txtarea.value(notificationValStr);
    }

    main.setHideDivBootstrap("DivValidateNotification", notificationValStr != "");

    return notificationValStr;      // not sure if this is needed
}


//--- TAB ROLES ---------------------------------------------------------------------------//

/**
* Init Tab roles
* @param {string} notsaved
*/
export function TAB_Roles_initialize(notsaved: string): void {
    _msg_notsaved = notsaved;
}

/**
* Tab roles - Enable save button
*/
export function TAB_Roles_enableSaveButton(): void {
    $("#saveButtonRoles").data("kendoButton").enable(true);
}

/**
* Tab roles - Disable save button
*/
export function TAB_Roles_disableSaveButton(): void {
    $("#saveButtonRoles").data("kendoButton").enable(false);
}

/**
* Tab roles - LDataNotSaved (label)
*/
export function TAB_Roles_Get_LDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

/**
* Tab roles - Left clicked
*/
export function TAB_Roles_leftClicked(): void {
    TAB_Roles_enableSaveButton();
    listbox.moveItems("User_Roles_CplSelected", "User_Roles_CplNotSelected", "#Roles_Validation", TAB_Roles_Get_LDataChangedNotSavedYet());
}

/**
* Tab roles - Right clicked
*/
export function TAB_Roles_rightClicked(): void {
    TAB_Roles_enableSaveButton();
    listbox.moveItems("User_Roles_CplNotSelected", "User_Roles_CplSelected", "#Roles_Validation", TAB_Roles_Get_LDataChangedNotSavedYet());
}

/**
* Tab roles - Save button clicked
* @param {string} actionUrl
* @param {number} userId
*/
export function TAB_Roles_saveButtonClicked(actionUrl: string, userId: number): void {

    TAB_Roles_disableSaveButton();

    const json = $("#User_Roles_CplSelected").data("kendoListBox").dataSource.view().toJSON();
    const list = json.slice();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { list: kendo.stringify(list), id: userId },
        success: function (responseData: responseModel | undefined | null) {

            $('#Roles_Validation').text("");

            const color = (responseData.Succesfully ? 'green' : 'red');
            $('#Roles_Validation').text(responseData.Message);
            $('#Roles_Validation').attr('style', 'color:' + color);
        }
    });

}

//--- TAB FUNCTIONS ---------------------------------------------------------------------------//

/**
* Tab functions - Init tab
* @param {string} notsaved
*/
export function TAB_Functions_initialize(notsaved: string): void {
    _msg_notsaved = notsaved;

    $("#notSelectedSearchBox").on("input", function () {
        const listBox = $("#User_Functions_CplNotSelected").data("kendoListBox");
        const searchString = $(this).val();

        listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
    });

    $("#selectedSearchBox").on("input", function () {
        const listBox = $("#User_Functions_CplSelected").data("kendoListBox");
        const searchString = $(this).val();

        listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
    });

    TAB_Functions_enableSaveButton();
}

/**
* Tab functions - LDataNotSaved (label)
*/
export function TAB_Functions_Get_LDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

/**
* Tab functions - Left clicked (move items)
*/
export function TAB_Functions_leftClicked(): void {
    TAB_Functions_enableSaveButton();
    listbox.moveItems("User_Functions_CplSelected", "User_Functions_CplNotSelected", "#Functions_Validation", TAB_Functions_Get_LDataChangedNotSavedYet());
}

/**
* Tab functions - Right clicked (move items)
*/
export function TAB_Functions_rightClicked(): void {
    TAB_Functions_enableSaveButton();
    listbox.moveItems("User_Functions_CplNotSelected", "User_Functions_CplSelected", "#Functions_Validation", TAB_Functions_Get_LDataChangedNotSavedYet());
}

/**
* Tab functions - Enable save button
*/
export function TAB_Functions_enableSaveButton(): void {
    $("#saveButtonFunctions").data("kendoButton").enable(true);
}

/**
* Tab functions - Disable save button
*/
export function TAB_Functions_disableSaveButton(): void {
    // $("#saveButtonFunctions").data("kendoButton").enable(false);
}

/**
* Tab functions - Move selected item
* @param {string} actionUrl
* @param {string} userId
*/
export async function TAB_Functions_saveButtonClicked(actionUrl: string, userId: number): Promise<void> {
    await TAB_Functions_save(actionUrl, userId);
    await tabFunctionsValidUntilSave();

    const tabstrip = $('#form_UserServiceFunctionValidUntil').closest(".k-tabstrip").first().data("kendoTabStrip");
    const tab = tabstrip.select();
    tabstrip.reload(tab);
}

function TAB_Functions_save(actionUrl: string, userId: number): Promise<void> {

    TAB_Functions_disableSaveButton();

    const listBox = $("#User_Functions_CplSelected").data("kendoListBox");
    listBox.dataSource.filter({ field: "Text", operator: "contains", value: "" });

    const json = listBox.dataSource.view().toJSON();
    const list = json.slice();

    return new Promise<void>((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: appsettings.getUrl(actionUrl),
            data: { list: kendo.stringify(list), id: userId },
            success: function (responseData: responseModel | undefined | null) {
                $('#Functions_Validation').text("");

                const color = (responseData.Succesfully ? 'green' : 'red');
                $('#Functions_Validation').text(responseData.Message);
                $('#Functions_Validation').attr('style', 'color:' + color);

                resolve();
            },
            error: (err) => reject(err)
        });
    });
}

function tabFunctionsValidUntilSave(): Promise<void> {
    form.submitForm('form_UserServiceFunctionValidUntil', 'User/SaveFunctionsValidUntil', false, '');

    return Promise.resolve();
}

/**
* Tab functions - Visibility
* @param {number} version
*/
export function tab_General_Visibility(version: number): void {

    const val = main.getKendoCheckBoxGroupValue("ANVal");

    main.setHideDivBootstrap("DivSoundsHeader", val > 0);

    main.setHideDivBootstrap("DivSoundAlarm", (val & 4) > 0);
    main.setHideDivBootstrap("DivSoundInfo", (val & 1) > 0);
    main.setHideDivBootstrap("DivSoundUnderstaffing", (val & 2) > 0);
    main.setHideDivBootstrap("DivSoundOccupancy", (val & 8) > 0);
    main.setHideDivBootstrap("DivSoundProposal", (val & 16) > 0);

    main.setHideDivBootstrap("DivGroupChangeMsgBy", version >= PagerVersionWPagerProfiles);

    clientSideValidation();
}


//--- TAB Capcodes ---------------------------------------------------------------------------//

/**
 * initialize with the userid
 * @param {number} userId
 */
export function TAB_Capcodes_initialize(userId: number): void {

    // Create new record ...
    $(document)
        .off("click.capcodesAdd", "#CapCodesGrid .k-grid-add")
        .on("click.capcodesAdd", "#CapCodesGrid .k-grid-add", function (e: JQuery.Event): void {
        // Prevent default behaviour
        e.preventDefault();
        TAB_Capcodes_showForm(true);
    });

    TAB_Capcodes_showForm(false);
    _userId = userId;
    grid.loadGridOptions("CapCodesGrid");
}

/**
 * Show or hide the capcode input.
 * @param {boolean} show
 */
export function TAB_Capcodes_showForm(show: boolean): void {

    if (show) {
        $("#formCapCode").show();
    } else {
        $("#formCapCode").hide();
    }

    main.makeResultMessage(null);
}

/**
 * Form submission event
 * @param {kendo.data.DataSourceEvent & { model: CapCodeModel }} e
 */
export function TAB_Capcodes_onFormSubmit(e: kendo.data.DataSourceEvent & { model: CapCodeModel }): void {

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl((e.model as CapCodeModel).FormAction),
        data: {
            capcode: (e.model as CapCodeModel).CapCode,
            userId: (e.model as CapCodeModel).UserID
        },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {
            refreshGrid();
            form.showServerResponse("formCapCode", responseData, function (e: any) { });
        }
    });

}

/**
 * Form clear, clear all form entries.
 */
export function TAB_Capcodes_onFormClear(): void {
    TAB_Capcodes_showForm(false);
    main.makeResultMessage(null);
}

/**
 * Sets enabled to true or false. Called when user clicks checkbox.
 * @param {HTMLInputElement} e
 * @param {number} capcodeId
 * @param {number} userId
 */
export function TAB_Capcodes_onEnableClicked(e: HTMLInputElement, capcodeId: number, userId: number): void {

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("User/SetEnabled"),
        data: {
            enabled: e.checked,
            capcode: capcodeId,
            userId: userId
        },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {
            main.makeResultMessage(responseData);
        }
    });
}

/**
 * Template for checkbox Enabled in grid
 * @param {CapcodeRow} data
 * @param {number} userId
 */
export function TAB_Capcodes_template(data: CapcodeRow, userId: number): string {
    return "<input name='cb' type='checkbox' " + (data.Enable ? "checked='checked'" : "") + " onclick='PreCom.Modules.user.TAB_Capcodes_onEnableClicked(this, " + data.Capcode + ", " + userId + " );' />";
}

/**
 * On deletion clicked
 * @param {JQuery.Event & { currentTarget: HTMLElement }} e
 */
export function TAB_Capcodes_onDeleteClicked(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour    
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as CapcodeGridVM;
        TAB_Capcodes_removeItemFromUser(dataItem.Capcode);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

/**
 * Remove an item from the selected user. The selected user is set on initial load of page.
 * @param {number} capcodeId
 */
export function TAB_Capcodes_removeItemFromUser(capcodeId: number): void {

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("User/RemoveCapCode"),
        data: {
            capcode: capcodeId,
            userId: _userId
        },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            TAB_Capcodes_refreshGrid();

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });

}

/**
 * Refreshes the grid with capcodes for a user
 */
export function TAB_Capcodes_refreshGrid(): void {

    const grid = $("#CapCodesGrid").data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read(_userId);
    }
}


//--- TAB Pager ---------------------------------------------------------------------------//

export function TAB_UserPager_Profile_Refresh(userId: number, profileNumber: number): void {
    $("#editTabstripUserPager-1").empty();
    $("#editTabstripUserPager-1").load(appsettings.getUrl("User/Tab_Pager_Profile?userId=" + userId + "&number=" + profileNumber));
}

export function TAB_UserPager_Profile_Capcodes_Refresh(userId: number, profileNumber: number): void {
    $("#DivProfileCapcodes").load(appsettings.getUrl("User/Tab_Pager_Profile_Capcodes?userId=" + userId + "&profileNumber=" + profileNumber + "&noButtons=false"));
}

export function TAB_UserPager_Profile_Checked(checked: { checked: boolean }): void {
    $("[id$='_Capcode']").prop('disabled', !checked.checked);
    $("[id$='_Active']").prop('disabled', !checked.checked);
    $("[id$='_Prio']").prop('disabled', !checked.checked);
    $("[id$='_Manual']").prop('disabled', !checked.checked);
    $("[id$='_Reply']").prop('disabled', !checked.checked);
    $("[id$='_TGS']").prop('disabled', !checked.checked);
    $("[id$='_TGScode']").prop('disabled', !checked.checked);
    $("[id$='_Label']").prop('disabled', !checked.checked);
    $("[id$='_AlertType']").prop('disabled', !checked.checked);
    $("[id$='_UserTonePattern']").prop('disabled', !checked.checked);
}

export function TAB_UserPager_Profile_TGSChanged(e: kendo.ui.CheckBoxChangeEvent): void {
    const tGSCodeDiv = $("#" + e.sender.element[0].id.replaceAll('_TGS', '_TGScode')).parent().closest('div')[0];
    setHideDiv(tGSCodeDiv, e.checked);
}

export function TAB_UserPager_Profile_AlertTypeChanged(e: kendo.ui.DropDownListChangeEvent): void {
    const userTonePatternDiv = $("#" + e.sender.element[0].id.replaceAll('_AlertType', '_UserTonePattern')).parent().closest('div')[0];

    if (e.sender.value() == "0") {
        setHideDiv(userTonePatternDiv, true);
    } else {
        setHideDiv(userTonePatternDiv, false);
    }
}
export function sourceTypeChanged(userId: number): void {
    Tab_Pager_Profile_Capcodes_refresh(userId);
}

export function TAB_Pager_CopyProfile_Initialize(userId: number) {
    Tab_Pager_Profile_Capcodes_refresh(userId);
}

function Tab_Pager_Profile_Capcodes_refresh(userId: number) {
    const sourceTypeDropDownList = $('#SourceType').data("kendoDropDownList");
    const sourceType = sourceTypeDropDownList.value();

    const copyFromNumberDropDownList = $('#CopyFromNumber').data("kendoDropDownList");
    const copyFromNumber = copyFromNumberDropDownList.value();

    const copyFromGroupDropDownList = $('#CopyFromGroup').data("kendoDropDownList");
    const copyFromGroup = copyFromGroupDropDownList.value();

    const copyFromHistoryDropDownList = $('#CopyFromHistory').data("kendoDropDownList");
    const copyFromHistory = copyFromHistoryDropDownList.value();

    showHideSourceType(sourceType);

    if (sourceType === '3') {
        $("#div_Tab_Pager_Profile_Capcodes").load(appsettings.getUrl("User/Tab_Pager_Profile_Capcodes_History?userId=" + userId + "&pagerProfileId_MomentUTCTicks=" + copyFromHistory + "&noButtons=true"), function () {
            viewmode.disableAllInputs("div_Tab_Pager_Profile_Capcodes");
        });
    } else if (sourceType === '2') {
        $("#div_Tab_Pager_Profile_Capcodes").load(appsettings.getUrl("User/Tab_Pager_Profile_Capcodes_Group?userId=" + userId + "&groupId=" + copyFromGroup), function () {
            viewmode.disableAllInputs("div_Tab_Pager_Profile_Capcodes");
        });
    }
    else {
        $("#div_Tab_Pager_Profile_Capcodes").load(appsettings.getUrl("User/Tab_Pager_Profile_Capcodes?userId=" + userId + "&profileNumber=" + copyFromNumber + "&noButtons=true"), function () {
            viewmode.disableAllInputs("div_Tab_Pager_Profile_Capcodes");
        });
    }
}

function showHideSourceType(sourceType: string): void {
    if (sourceType === '3') {
        main.setHideDivBootstrap("TRCopyFromNumber", false);
        main.setHideDivBootstrap("TRCopyFromGroup", false);  
        main.setHideDivBootstrap("TRCopyFromHistory", true);
    } else if (sourceType === '2') {
        main.setHideDivBootstrap("TRCopyFromNumber", false);
        main.setHideDivBootstrap("TRCopyFromGroup", true);
        main.setHideDivBootstrap("TRCopyFromHistory", false);
    } else {
        main.setHideDivBootstrap("TRCopyFromNumber", true);
        main.setHideDivBootstrap("TRCopyFromGroup", false);  
        main.setHideDivBootstrap("TRCopyFromHistory", false);
    }
}

export function setHideDiv(element: HTMLElement, showBool: boolean): void {

    if (element !== undefined && element !== null) {

        if (element.style != undefined) {
            if (showBool) {
                element.style.visibility = "visible";  // "inline";
            } else {
                element.style.visibility = "hidden";
            }
        } else {
            element[0].hidden = !showBool;
        }
    }

    /*$("#" + id + " input").attr("data-validate", showBool);*/
}

export function TAB_UserPager_CancelForm_Clicked(): void {
    history.back();
}

export function TAB_UserPager_SubmitForm_Clicked(formid: string, actionUrl: string): void {
    if ($("#form_Tab_Pager_Profile")[0] != null) {
        const formId_profile = $("#form_Tab_Pager_Profile").find("input#FormName").val().toString();
        const formAction_profile = $("#form_Tab_Pager_Profile").find("input#FormAction").val().toString();
        form.submitForm(formId_profile, formAction_profile, false, '');
    }

    form.submitForm(formid, actionUrl, false, '');
}

//export function onPagerFormSubmit(e: any): void {

//    // Prevent default behaviour
//    e.preventDefault();

//    // Post Data
//    $.ajax({
//        type: "POST",
//        url: appsettings.getUrl(e.model.FormAction),
//        data: e.model,
//        success: function (responseData: responseModel | undefined | null) {
//            form.showServerResponse("", responseData, function () { });
//        }
//    });
//}

export function TAB_UserPager_AccuGSMSignal_Clicked(userId: number): void {
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("User/PagerRequestAccuGSMSignal") + "?userId=" + userId,
        success: function (responseData: responseModel | undefined | null) {
            if (responseData != undefined && responseData != null) {
                main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
            }
        }
    });
}


export async function TAB_UserPager_Send_Clicked(formid: string, actionUrl: string, userId: number): Promise<void> {

    let response: responseModel = { Succesfully: true, Message: "" };

    // 1. submit form
    if ($("#form_Tab_Pager_Profile")[0] != null) {
        const formId_profile = $("#form_Tab_Pager_Profile").find("input#FormName").val().toString();
        const formAction_profile = $("#form_Tab_Pager_Profile").find("input#FormAction").val().toString();
        response = await form.submitForm(formId_profile, formAction_profile, false, '');
    }

    if (response.Succesfully) {
        response = await form.submitForm(formid, actionUrl, false, '');
    }

    if (response.Succesfully) {
        // 2. send to pager
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("User/PagerSend") + "?userId=" + userId,
            success: function (responseData: responseModel | undefined | null) {

                if (responseData != undefined && responseData != null) {
                    main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }
        });
    }    
}


export function TAB_UserPager_Request_Clicked(userId: number): void {
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("User/PagerRequest") + "?userId=" + userId,
        success: function (responseData: responseModel | undefined | null) {
            if (responseData != undefined && responseData != null) {
                main.openActionsDialog(' ', responseData.Message,
                    [{ text: 'Ok', action: function () { main.closePopup(); } }]);

                //TODO:
                //main.setHideDiv("BRefresh", true);
            }
        }
    });
}


export function TAB_UserPager_Refresh_Clicked(): void {
    const tabstrip = $('#userPager_Refresh').closest(".k-tabstrip").first().data("kendoTabStrip");
    const tab = tabstrip.select();
    tabstrip.reload(tab);
}


export function TAB_UserPager_BUpdateFirmware_Clicked(userId: number): void {
    const selectedNewFirmwareVersion = $("#NewFirmwareVersion").data("kendoDropDownList").value();

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("User/Update_Firmware") + "?userId=" + userId + "&newFirmwareVersion=" + selectedNewFirmwareVersion,
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
            }
        }
    });
}

export function TAB_UserPager_BSendNac_Clicked(userId: number): void {
    const selectedNacId = $("#NacId").data("kendoDropDownList").value();

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("User/Update_Provider_Nac") + "?userId=" + userId + "&nacId=" + selectedNacId,
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
            }
        }
    });
}

export function TAB_UserPager_BSendCancelLocation_Clicked(userId: number): void {
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("User/Send_Cancel_Location") + "?userId=" + userId,
        success: function (responseData: responseModel | undefined | null) {
            if (responseData != undefined && responseData != null) {
                main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
            }
        }
    });
}

export function TAB_UserPager_Initialize(firmwareVersion: string) {
    TAB_UserPager_Options_CustomSoundToggle('FilterSoundType1', 'DivFilterCustomSound1');
    TAB_UserPager_Options_CustomSoundToggle('FilterSoundType3', 'DivFilterCustomSound3');
    TAB_UserPager_Options_CustomSoundToggle('FilterSoundType2', 'DivFilterCustomSound2');

    if (parseInt(firmwareVersion, 10) >= 700) {
        main.setHideDivBootstrap('DivFilterFields', true);
    } else {
        main.setHideDivBootstrap('DivFilterFields', false);
    }
}

export function TAB_UserPager_Options_CustomSoundToggle(filterSoundTypeId: string, divId: string) {
    const filterDropdown = $('#' + filterSoundTypeId).data("kendoDropDownList");

    if (filterDropdown) {
        const value = filterDropdown.value();
        if (value === "0") {
            main.setHideDivBootstrap(divId, true);
        } else {
            main.setHideDivBootstrap(divId, false);
        }
    }
}

//--- TAB_UserGroupSwitch --------------------------------------------------------------------------------//

export function initialize_GroupSwitchForm(userId: number): void {

    // Create new record ...
    $(document)
        .off("click.overviewAdd", "#GroupChangeGrid .k-grid-add")
        .on("click.overviewAdd", "#GroupChangeGrid .k-grid-add", function (e: JQuery.Event): void {
        // Prevent default behaviour
        e.preventDefault();

        $("#UserGroupSwitchForm").load(appsettings.getUrl("User/AddGroupChange?userId=" + userId));
    });
    grid.loadGridOptions("GroupChangeGrid");
    show_DivGroupSwitchForm(false);
    _userId = userId;
}


/**
 * show a item (param is event data)
 */
export function edit_GroupSwitchForm(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    var dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupChangeVM;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // $("#UserGroupSwitchForm").load(appsettings.getUrl("User/EditItem?groupUserId=" + dataItem.GroupUserID + "&breadcrumbLabel=" + dataItem.GroupLabel));
    $("#UserGroupSwitchForm").load(appsettings.getUrl("User/EditItem?groupUserId=" + dataItem.GroupUserID));
}


/**
 * Show or hide the group switch input.
 * @param {boolean} show
 */
export function show_DivGroupSwitchForm(show: boolean): void {

    if (show) {
        $("#formGroupChange").show();
    } else {
        $("#formGroupChange").hide();
    }

    main.makeResultMessage(null);
}

/**
 * Refreshes the grid 
 */
export function refreshGrid(): void {
    const grid = $("#GroupChangeGrid").data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read(_userId);
    }
}


//--- TAB UserGroupChange ---------------------------------------------------------------------------//

export function TAB_UserGroupChange_GetListBoxSelectedValue(listboxName: string): number {
    const listBox = $(listboxName).data("kendoListBox");
    const allItems = listBox.items();
    const selectedItems = listBox.select();

    const index = allItems.index(selectedItems[0]);
    const item = listBox.dataSource.view()[index];
    if (item != undefined) {
        return item.Value;
    } else {
        return -1;
    }
}

export function TAB_UserGroupChange_SetListBoxSelectedValue(listboxName: string, value: number): void {

    const listBox = $(listboxName).data("kendoListBox");
    const allItems = listBox.dataItems().toJSON() as SelectListItemExtended[];
    const items = allItems.filter(f => f.Value == value.toString());

    if (items !== undefined) {
        const item = listBox.wrapper.find("[data-uid='" + items[0].uid + "']");
        listBox.select(item);
    }
}

export function TAB_UserGroupChange_GroupAdd_Clicked(formId: string, userId: number): void {
    const actionUrl = "User/UserGroupChange_GroupAdd";
    const fieldName = "#TBGroupChangeGroup";
    const data = { userId: userId, ID: Number($(fieldName).val()) };

    form.submitData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');

    currentSelectedGroupId = undefined;
    currentSelectedAdditionalGroupId = undefined;
}

export function TAB_UserGroupChange_AdditionalGroupAdd_Clicked(formId: string): void {
    const actionUrl = "User/UserGroupChange_AdditionalGroupAdd";
    const userGroupChangeId = Number(TAB_UserGroupChange_GetListBoxSelectedValue("#LBoxUserGroupChange_Groups"));
    const fieldName = "#TBGroupChangeAdditionalGroup";
    const data = { userGroupChangeId: userGroupChangeId, ID: Number($(fieldName).val()) };

    form.submitData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');

    currentSelectedAdditionalGroupId = undefined;
}

export function TAB_UserGroupChange_AdditionalFunctionAdd_Clicked(formId: string): void {
    const actionUrl = "User/UserGroupChange_AdditionalFunctionAdd";
    const userGroupChangeAdditionalGroupId = Number(TAB_UserGroupChange_GetListBoxSelectedValue("#LBoxUserGroupChange_AdditionalGroups"));
    const fieldName = "#DDLGroupChangeAdditionalFunction";
    const data = { userGroupChangeAdditionalGroupId: userGroupChangeAdditionalGroupId, serviceFunctionId: Number($(fieldName).val()) };

    form.submitData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');
}

export function TAB_UserGroupChange_GroupDelete_Clicked(formId: string): void {
    const actionUrl = "User/UserGroupChange_GroupDelete";
    const fieldName = "#LBoxUserGroupChange_Groups";
    const userGroupChangeId = TAB_UserGroupChange_GetListBoxSelectedValue(fieldName);

    const data = { userGroupChangeId: Number(userGroupChangeId) };

    form.deleteData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');

    currentSelectedGroupId = undefined;
    currentSelectedAdditionalGroupId = undefined;
}

export function TAB_UserGroupChange_AdditionalGroupDelete_Clicked(formId: string): void {
    const actionUrl = "User/UserGroupChange_AdditionalGroupDelete";
    const fieldName = "#LBoxUserGroupChange_AdditionalGroups";
    const userGroupChangeAdditionalGroupId = TAB_UserGroupChange_GetListBoxSelectedValue(fieldName);

    const data = { userGroupChangeAdditionalGroupId: Number(userGroupChangeAdditionalGroupId) };

    form.deleteData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');

    currentSelectedAdditionalGroupId = undefined;
}

export function TAB_UserGroupChange_AdditionalFunctionDelete_Clicked(formId: string): void {
    const actionUrl = "User/UserGroupChange_AdditionalFunctionDelete";
    const fieldName = "#LBoxUserGroupChange_AdditionalFunctions";
    const userGroupChangeAdditionalFunctionId = TAB_UserGroupChange_GetListBoxSelectedValue(fieldName);

    const data = { userGroupChangeAdditionalFunctionId: Number(userGroupChangeAdditionalFunctionId) };

    form.deleteData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');
}

export function TAB_UserGroupChange_LBox_Groups_Clicked(userId: number, e: kendo.ui.ListBoxEvent): void {

    const fieldNameG = "#LBoxUserGroupChange_AdditionalGroups";
    const element = e.sender.select();
    const dataItem = e.sender.dataItem(element[0]) as UserGroupChangeItem;
    const userGroupChangeId = dataItem.Value;

    filterData(fieldNameG, userGroupChangeId.toString());

    const fieldNameF = "#LBoxUserGroupChange_AdditionalFunctions";
    let userGroupChangeAdditionalGroupId = Number($('#LBoxUserGroupChange_AdditionalGroups').val());
    filterData(fieldNameF, userGroupChangeAdditionalGroupId.toString());

    TAB_UserGroupChange_Refresh_AdditionalFunction(userId, userGroupChangeAdditionalGroupId);

    currentSelectedGroupId = userGroupChangeId;
    currentSelectedAdditionalGroupId = undefined;
}

export function TAB_UserGroupChange_LBox_AdditionalGroups_Clicked(userId: number, e: kendo.ui.ListBoxEvent): void {
    const fieldName = "#LBoxUserGroupChange_AdditionalFunctions";
    const element = e.sender.select();
    const dataItem = e.sender.dataItem(element[0]) as UserGroupChangeItem;
    const userGroupChangeAdditionalGroupId = dataItem.Value;

    filterData(fieldName, userGroupChangeAdditionalGroupId.toString());

    TAB_UserGroupChange_Refresh_AdditionalFunction(userId, userGroupChangeAdditionalGroupId);

    currentSelectedAdditionalGroupId = userGroupChangeAdditionalGroupId;
}

export function TAB_UserGroupChange_Refresh_All(userId: number): void {

    if (currentSelectedGroupId === undefined) {
        const listBox_Groups = $("#LBoxUserGroupChange_Groups").data("kendoListBox");
        listBox_Groups.select(listBox_Groups.items().first());
    }
    else {
        TAB_UserGroupChange_SetListBoxSelectedValue("#LBoxUserGroupChange_Groups", currentSelectedGroupId);
    }

    const userGroupChangeId = TAB_UserGroupChange_GetListBoxSelectedValue("#LBoxUserGroupChange_Groups").toString()
    filterData("#LBoxUserGroupChange_AdditionalGroups", userGroupChangeId);

    let userGroupChangeAdditionalGroupId: number;
    if (currentSelectedAdditionalGroupId === undefined) {
        const listBox_AdditionalGroups = $("#LBoxUserGroupChange_AdditionalGroups").data("kendoListBox");
        listBox_AdditionalGroups.select(listBox_AdditionalGroups.items().first());
        userGroupChangeAdditionalGroupId = Number($('#LBoxUserGroupChange_AdditionalGroups').val());
    }
    else {
        TAB_UserGroupChange_SetListBoxSelectedValue("#LBoxUserGroupChange_AdditionalGroups", currentSelectedAdditionalGroupId);
        userGroupChangeAdditionalGroupId = currentSelectedAdditionalGroupId;
    }

    filterData("#LBoxUserGroupChange_AdditionalFunctions", userGroupChangeAdditionalGroupId.toString());

    // listBox_AdditionalGroups.select(listBox_AdditionalGroups.items().first());  why this line ?

    TAB_UserGroupChange_Refresh_AdditionalFunction(userId, Number(userGroupChangeAdditionalGroupId));

    const listBox_AdditionalFunctions = $("#LBoxUserGroupChange_AdditionalFunctions").data("kendoListBox");
    listBox_AdditionalFunctions.select(listBox_AdditionalFunctions.items().first());
}

export function TAB_UserGroupChange_Refresh_AdditionalFunction(userId: number, userGroupChangeAdditionalGroupId: number): void {
    // Get Data
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("User/GetAllFunctionsUser"),
        data: { userId: userId, userGroupChangeAdditionalGroupId: userGroupChangeAdditionalGroupId },
        success: function (responseData: { selectListItems: SelectListItem[] }) {
            if (responseData != undefined) {
                var dropDownList = $("#DDLGroupChangeAdditionalFunction").data("kendoDropDownList");
                dropDownList.dataSource.data(responseData.selectListItems);
            }
        }
    });
}

export function filterData(fieldName: string, searchString: string): void {
    const listBox = $(fieldName).data("kendoListBox");
    listBox.dataSource.filter({ field: "ParentValue", operator: "contains", value: searchString });
}
